import { BasicService } from "./core/basic.service";

export class RoleService extends BasicService {

  static async getList() {
    const data = await this.http.post('/power/RoleList');
    data.forEach(item => {
      item.is_enable = !!item.is_enable;
    });
    return Promise.resolve(data);
  }

  static detail(role_id) {
    return this.http.post('/power/RoleList', { role_id } )
  }

  static addOrEditRole(data) {
    return this.http.post('/power/RoleSave', data);
  }

  static deleteRole(role_id) {
    return this.http.post('/power/RoleDelete', { role_id });
  }

  static switchRoleStatus(role_id, is_enable) {
    return this.http.post('/power/RoleStatusUpdate', { role_id, is_enable } )
  }

  static async getFormTreeData() {
    const data = await this.http.post('/power/Index');
    const stack = [...data];
    let flag = stack.pop();
    while (flag) {
      flag.isLeaf = flag.type !== '2';
      flag.class = flag.isLeaf ? `Leaf ${flag.type === '0' ? 'interface' : 'view'}` : 'AppMenu';
      if (flag.sub && flag.sub.length) {
        stack.unshift(...flag.sub);
      }
      flag = stack.pop();
    }
    return Promise.resolve(data);
  }
}